import { FormattedMessage } from "react-intl";
import { PasswordRules as SharedPasswordRules } from "@shltelemedicine/shl-ui-lib";

const PasswordRules = () => {
  return (
    <SharedPasswordRules
      rules={[
        <FormattedMessage
          id="PASSWORD_RULES.MIN_LENGTH"
          defaultMessage="At least 8 characters-the more characters, the better"
        />,
        <FormattedMessage
          id="PASSWORD_RULES.LETTERS_UPPER_LOWER_MIX"
          defaultMessage="A mixture of both uppercase and lowercase letters"
        />,
        <FormattedMessage
          id="PASSWORD_RULES.LETTERS_NUMBERS_MIX"
          defaultMessage="A mixture of letters and numbers"
        />,
        <FormattedMessage
          id="PASSWORD_RULES.SPECIAL_CHAR"
          defaultMessage="Inclusion of at least one special character, e.g., ! @ # ? ]"
        />,
        <FormattedMessage
          id="PASSWORD_RULES.DIFFERENT_FROM_LAST"
          defaultMessage="Choose a password that is different from your last"
        />,
        <FormattedMessage
          id="PASSWORD_RULES.NOTE"
          defaultMessage="Note: do not use < or > in your password,<br></br>as both can cause problems in Web browsers"
          values={{
            br: () => <br></br>,
          }}
        />,
      ]}
    />
  );
};

export default PasswordRules;
